export const getRules = (tableData, tiers) => {
    if (tableData.type === 'MemberStreakDefault')
        return ['Membership streak badge'];
    if (tableData.type === 'Custom') {
        return tableData.rules.map((rule) => {
            if (rule.type === 'CommentsWritten') {
                if (rule.minimum && rule.maximum) {
                    return `Wrote ${rule.minimum} to ${rule.maximum} comments`;
                }
                return `Wrote at least ${rule.minimum} comments`;
            }
            if (rule.type === 'LikesGiven') {
                if (rule.minimum && rule.maximum) {
                    return `Gave ${rule.minimum} to ${rule.maximum} likes`;
                }
                return `Gave ${rule.minimum} likes`;
            }
            if (rule.type === 'LikesReceived') {
                if (rule.minimum && rule.maximum) {
                    return `Received ${rule.minimum} to ${rule.maximum} likes`;
                }
                return `Received ${rule.minimum} likes`;
            }
            if (rule.type === 'Tier') {
                const tier = tiers?.tiers.find((tier) => tier.id === rule.tierId);
                return `${tier ? tier.name : rule.tierId} members`;
            }
        });
    }
};
